import React, { useEffect, useState } from "react";
import Routes from "./routes/Routes";
import "./assets/scss/main.scss";
import { GlobalContext } from "./context";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Toaster } from "react-hot-toast";

function App() {
  const [size, setSize] = useState("medium");
  const [price, setPrice] = useState(localStorage.getItem("Isprice"));
  const [themeMode, setThemeMode] = useState(
    localStorage.getItem("theme") ? localStorage.getItem("theme") : "light"
  );

  useEffect(() => {
    document.body.classList.remove("dark-theme");
  }, []);

  return (
    <>
      <GlobalContext.Provider
        value={{ size, setSize, themeMode, setThemeMode, price, setPrice }}
      >
        <div className={`App ${size}`}>
        <Toaster position="top-right" reverseOrder={true} />
          <Routes />
        </div>
      </GlobalContext.Provider>
    </>
  );
}

export default App;
